<div id="sentDisablingOverlay">
    <div class="overlayText">
        <div class="overlayTextHeader">{{'confirmDisableSentSendTitle' | translate}}</div>
        <div class="overlayTextMain">
          {{'confirmDisableSentSendDescription'|translate}}
        </div>
        <div class="overlayButtons">
            <button class="overlayButtonAccept" (click)="dialogRef.close(true)">
              {{'vehicle-details-etoll-tab.turn-off-confirm' | translate | titlecase}}
            </button>
            <button class="overlayButtonCancel" (click)="dialogRef.close(false)">
              {{'labels.cancel' | translate | titlecase}}
            </button>
        </div>
    </div>
</div>